import { EntityRoutes } from 'routes/constants';
import { CandidateIncludes } from 'services/includes';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { CandidateEntity, ENTITY_TYPE_ID_MAP, TabKeys } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const CANDIDATE_DRAWERS = {
  AddHiringAuthority: 'addHiringAuthority',
  Claim: 'claim',
  Edit: 'edit',
  LinkHiringAuthority: 'linkHiringAuthority',
  Presentation: 'presentation',
  Recruiters: 'recruiters',
  Roleplay: 'roleplay',
  Sendout: 'sendout',
  Task: 'task',
  VerifyUrgency: 'verifyUrgency'
};

export const CANDIDATE_TAB_IDS = {
  ActionPlan: TabKeys.Tasks,
  JobOrders: TabKeys.JobOrders,
  MatchMaking: TabKeys.MatchMaking,
  Overview: TabKeys.Overview,
  Placements: TabKeys.Placements,
  ReferenceChecks: TabKeys.ReferenceCheck,
  Resume: TabKeys.ResumeViewer,
  Sendouts: TabKeys.Sendouts
};

export const CANDIDATE_PROFILE_CONFIG = {
  endpoint: Endpoints.Candidates,
  entityTypeId: ENTITY_TYPE_ID_MAP.candidate,
  id: CandidateEntity.id,
  includes: () => [CandidateIncludes],
  requestAssignmentLabel: strings.inventoryProfiles.common.startMarketing,
  route: id => EntityRoutes.CandidateProfile.replace(':id', id),
  sectionName: CandidateEntity.singular,
  tabsStorageKey: PERSISTENCE_KEYS.PROFILE_TABS.CANDIDATES,
  tabsSubheader: `${CandidateEntity.singular} ${strings.inventoryProfiles.title}`,
  title: CandidateEntity.title,
  trackingUrl: Endpoints.CandidateRecentlyViewed,
  type: 'candidate'
};
